var _defs, _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIzicareLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 650 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463.2,120.6h0c-3,0-5.5-1.3-5.5-5.7v-58.8c0-3.3-2.7-6-6-6h-17.3c-.9,0-1.7.6-1.9,1.5h0c-.3,1.3-1.8,1.9-3,1.2-6.5-3.9-14.1-5.4-22.5-5.4-28.3,0-49.5,21.1-49.5,53.3s17.7,49.2,42.6,49.2,25.2-6.6,30.5-14.1c2.6,7.5,8.9,12.8,21.7,12.8s12.2-1.3,16.8-3.4v-19.1c0-3.2-2.6-5.6-5.8-5.6h0ZM426.9,110.1c0,1-.2,2-.7,2.9-3.2,5.7-10.2,9.1-17,9.1-11.7,0-20-7.7-20-23.2s9.2-25.2,21.5-25.2,9.4.8,13.3,3.1c1.8,1.1,2.9,3.1,2.9,5.2v28.2h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.4,50h-4.8c-7.2,0-13.1,5.8-13.1,13v84.3h30.9V63c0-7.2-5.8-13-13-13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.4,50h-4.8c-7.2,0-13.1,5.8-13.1,13v84.3h30.9V63c0-7.2-5.8-13-13.1-13h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.3,23.6c-9.2-2.5-18.1-3.6-28-3.6-39.2,0-66.5,24.9-66.5,66.7s28.6,63.3,67.1,63.3,23.5-1.9,31.8-4.7v-19.9c0-4.1-4-6.9-7.8-5.7-6,1.8-12,2.7-19.5,2.7-25.8,0-39.9-13.6-39.9-37.1s13.9-37.5,39.2-37.5,13.7,1,20.2,3.2c3.9,1.3,7.9-1.7,7.9-5.7v-15.8c0-2.7-1.8-5.1-4.4-5.8h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M544.3,48.2c-1.7-.2-3.4-.3-5.4-.3-7.9,0-16,3.4-21.5,10.1-1.6,2-4.8,1.3-5.3-1.2l-.4-1.9c-.6-2.8-3-4.7-5.9-4.7h-14.2c-3.3,0-6,2.7-6,6v91.2h30.9v-47.1c.8-18.1,11.7-24.3,22.4-24.3s2.7,0,3.9.2c3.6.4,6.7-2.4,6.7-6v-16c0-3-2.2-5.5-5.2-6h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M603.1,47.5c-29,0-50.1,20.2-50.1,51.2s28.1,51.2,53.9,51.2,25.2-1.5,36.7-7.4v-15.7c0-4.1-4-7-7.9-5.7-8.1,2.7-15.7,4.1-23,4.1-13.4,0-22.6-4.7-26.6-14.3-.8-2,.6-4.2,2.8-4.2h54.9c3.2,0,5.9-2.6,6-5.8,0-2.2.1-4.6.1-7.2-.6-30-18.7-46.3-46.9-46.3h0ZM616.8,89.5h-28.3c-2,0-3.5-2-2.9-3.9,2.9-9.1,9.2-13.4,17.5-13.4s14.7,4.2,16.6,13.8c.4,1.8-1.1,3.6-3,3.6h0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 20,
    cy: 20,
    r: 20
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 172.1,
    cy: 20,
    r: 20
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.1,50.1H59.2c-3.3,0-6,2.7-6,6v13c0,3.3,2.7,6,6,6h54c2.6,0,3.9,3,2.3,4.9l-17,20.4c-2.2,2.6-.3,6.6,3.1,6.6h9c1.2,0,2.3-.5,3.1-1.5l23.9-29c.9-1.1,1.4-2.4,1.4-3.8v-16.7c0-3.3-2.7-6-6-6h0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.1,122.3h-54c-2.6,0-3.9-3-2.3-4.9l17-20.4c2.2-2.6.3-6.6-3.1-6.6h-9c-1.2,0-2.3.5-3.1,1.5l-23.9,29c-.9,1.1-1.4,2.4-1.4,3.8v22.8h85.9v-19c0-3.3-2.7-6-6-6h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIzicareLogoWhite);
export default __webpack_public_path__ + "static/media/izicare_logo_white.646d27cd5d792e48363489af4b4c78c8.svg";
export { ForwardRef as ReactComponent };